export const actionType = Object.freeze({
    UPDATE_USER_PRINCIPAL_MAPPING: 'migration.update-user-principal-mapping',
});

const reducer = (preState = {}) => {
    return preState;
}

export default reducer;